import type { Column } from 'react-table';

import type { PlayerListElement } from '@swf/generated/types/api/v0/SwHomeGames';

import {
  TXTACL_Player,
  TXTCLI_Country,
  TXTCLI_Member_Since,
  TXTCLI_Status
} from './utils.messages.json';

export type Member = Omit<PlayerListElement, 'role' | 'enrolled'> & {
  enrolled: JSX.Element;
  role: JSX.Element;
};

export const columns: Column<Member>[] = [
  { Header: TXTACL_Player.defaultMessage, accessor: 'userId' },
  { Header: TXTCLI_Status.defaultMessage, accessor: 'role' },
  { Header: TXTCLI_Country.defaultMessage, accessor: 'location' },
  { Header: TXTCLI_Member_Since.defaultMessage, accessor: 'enrolled' }
];

export const columnsNonMembers: Column<Member>[] = [
  { Header: TXTACL_Player.defaultMessage, accessor: 'userId' },
  { Header: TXTCLI_Country.defaultMessage, accessor: 'location' }
];
